/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutQuote
 */
export interface CarveOutQuote {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    document_id: string;
    /**
     * 
     */
    document_name?: string;
}

/**
 * Check if a given object implements the CarveOutQuote interface.
 */
export function instanceOfCarveOutQuote(value: object): value is CarveOutQuote {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    return true;
}

export function CarveOutQuoteFromJSON(json: any): CarveOutQuote {
    return CarveOutQuoteFromJSONTyped(json, false);
}

export function CarveOutQuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutQuote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document_id': json['document_id'],
        'document_name': json['document_name'] == null ? undefined : json['document_name'],
    };
}

export function CarveOutQuoteToJSON(json: any): CarveOutQuote {
    return CarveOutQuoteToJSONTyped(json, false);
}

export function CarveOutQuoteToJSONTyped(value?: CarveOutQuote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'document_id': value['document_id'],
        'document_name': value['document_name'],
    };
}

